import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Hero from "./components/Hero";
import Section from "./components/Section";
import AboutUs from "./components/AboutUs";
import BusinessSolutions from "./components/BusinessSolutions";
import Footer from "./components/Footer";
import ContactUs from "./components/ContactUs";

import Privacy from "./components/Privacy";
import CookieBanner from "./components/CookieBanner"; // <-- Import CookieBanner
import Navbar from "./components/Navbar";
import Company from "./components/Company";

function App() {
  return (
    <Router>
      <Navbar/>
      

      <Routes>
      
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Section />
            </>
          }
        />

        
        <Route path="/about-us" element={<Company />} />
        <Route path="/services" element={<BusinessSolutions />} />
        <Route path="/contact" element={<ContactUs/>} />
        
        <Route path="/privacy-policy" element={<Privacy />} />
      </Routes>

    
      <Footer />

    
      <CookieBanner /> 
    </Router>
  );
}

export default App;
